export const INPUT:string= "INPUT";

export const SELECT:string = "SELECT";

export const CHECKBOX:string = "checkbox";

export const RADIO:string = "radio";

export const FILE:string = "file";

export const TEXTAREA:string = "textarea";



